/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ d: NonNullable<unknown>, h: NonNullable<unknown> }} Double_Pumps_Permutation_TextInputs */



/**
* | output |
* | --- |
* | "Double pumps swap every {d} to {h}." |
*
* @param {Double_Pumps_Permutation_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const double_pumps_permutation_text = /** @type {((inputs: Double_Pumps_Permutation_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Double_Pumps_Permutation_TextInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Double pumps swap every ${i?.d} to ${i?.h}.`)
	return /** @type {LocalizedString} */ (`Les pompes doubles permutent tous les ${i?.d} à ${i?.h}`)
});